import React from 'react';

import { SpinnerOverlay, SubmissionButtons } from '@components/common';

import { useMutateUpdateAsset } from '@hooks/assets/useMutateUpdateAsset';

import { isEmpty, isEqual } from '@utils/common';

import { TAsset } from '@interfaces/assets/asset';
import { ICoords } from '@interfaces/map/map';

import styles from '../LocationChangeView.module.scss';

interface IAssetLocationChangeViewProps {
	asset: TAsset;
	newCoords?: ICoords;
	reset: () => void;
}

const AssetLocationChangeView = ({
	asset,
	newCoords,
	reset,
}: IAssetLocationChangeViewProps) => {
	const {
		handleUpdateAsset,
		isLoadingUpdateAsset,
	} = useMutateUpdateAsset(asset.id, [reset]);

	const initialCoords = {
		lat: asset.lat,
		lng: asset.lng,
	};

	const submit = () => {
		if (!newCoords) return;

		handleUpdateAsset({
			id: asset.id,
			data: {
				...asset,
				powerSupplyAvailabilityStatus: asset?.powerSupplyAvailabilityStatus?.name || null,
				assetSiteAvailabilityStatus: asset?.assetSiteAvailabilityStatus?.name || null,
				backhaulAccessibilityStatus: asset?.backhaulAccessibilityStatus?.name || null,
				assetTypeId: asset.assetType.id,
				subType: asset?.assetSubType?.id || null,
				responsible: asset?.responsible?.name || null,
				lat: newCoords.lat,
				lng: newCoords.lng,
				assetSiteAvailabilityDetailsFileIds: asset?.assetSiteAvailabilityDetailsFileIds?.map((file) => file.id),
				assetAccessDetailsFileIds: asset?.assetAccessDetailsFileIds?.map((file) => file.id),
				backhaulAccessibilityDetailsFileIds: asset?.backhaulAccessibilityDetailsFileIds?.map((file) => file.id),
				powerSupplyAvailabilityDetailsFileIds: asset?.powerSupplyAvailabilityDetailsFileIds
					?.map((file) => file.id),
				specialImplementationIssueDetailsFileIds: asset?.specialImplementationIssueDetailsFileIds
					?.map((file) => file.id),
			},
		});
	};

	return (
		<div>
			{isLoadingUpdateAsset && <SpinnerOverlay />}
			<div className={styles.title}>{asset.assetType.assetTypeName}</div>
			{asset?.assetSubType && (
				<div className={styles.subtitle}>{asset.assetSubType.assetSubTypeName}</div>
			)}
			<div className={styles.markerId}>
				<span>Asset Site ID:&nbsp;</span>
				{asset.assetId}
			</div>
			<div className={styles.newLocation}>
				<div className={styles.title}>New location:</div>
				<div className={styles.coords}>
					<div>
						<span>Latitude:&nbsp;</span>
						{newCoords?.lat || asset.lat}
					</div>
					<div>
						<span>Longitude:&nbsp;</span>
						{newCoords?.lng || asset.lng}
					</div>
				</div>
			</div>
			<SubmissionButtons
				disabledPositive={isEmpty(newCoords) || isEqual(newCoords, initialCoords)}
				negativeHandler={reset}
				positiveHandler={submit}
				positiveLabel='Apply'
			/>
		</div>
	);
};

export default AssetLocationChangeView;
